import React, { memo, useCallback, useEffect, useState } from 'react';
import { View, Text, Button, StyleSheet, StatusBar, TouchableOpacity, ActivityIndicator, FlatList } from 'react-native-web';
import { connect, useDispatch, useSelector } from "react-redux";
import { GetAppointmentDate, GetMonthName, GetYear } from '../../../shared/core/datehelper'
import { fetchSentMessageFromApi } from "../../../shared/actions/SentMessageActions";
import { clearSetItemMessage, setItemMessage } from '../../../shared/actions/SetMessageItemAction';
import MessageItem from "../../components/MessageItem";
import { getInitials } from '../../../shared/core/utils';
import { Link } from 'react-router-dom';
import getUserInfo from '../../../shared/core/GetTokenized';
import { appServices } from '../../../shared/redux/actions/appServices';
const Sent = props => {
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const PatienInformation = JSON.parse(information);
    // const { SentItems, isGetting } = props.SentItems;
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const { SendMessage, isSending, isSendMessageSuccess, error } = useSelector((state)=>state.NewMessages)
    const { Messaging, isGetting } = useSelector((state)=> state.Messaging)
    const dispatch=useDispatch()
    const [pageSize, setPageSize] = useState(100);           //state for the page number
    const [pageNumber, setPageNumber] = useState(1);           //state for the page number
    
    const msgObj={
        PatientID:Profile[0].resource.id,
        PageSize  : pageSize,
        PageNumber: pageNumber ,
        Type :1,
        MessagingType : 2,
    }  
    useEffect(() => {
        //alert('Called Future')
        if(props.activeKey==="2" && Profile){
        dispatch (appServices.Messaging(msgObj))
    }
        // props.getMessage(pageSize, pageNumber)
    }, [props.activeKey , Profile])


    const getMessageId = params => {
        console.log("for Hassan====>  " + params)
        props.setMessageItem(params, 'Sent')
    }


    return (
        <>
            {
                isGetting && <View style={{ textAlign: 'center', marginTop: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
            }
            {
                Messaging && Messaging.length ? (
                    <FlatList
                        style={{ marginTop: 0, height: 700 }}
                        data={Messaging}
                        renderItem={({ item }) => (
                            // <TouchableOpacity onPress={() => {
                            //     getMessageId(item.resource.id)
                            // }}>
                            // <Link to={{
                            //     pathname: '/read',
                            //     state: { "id": item.resource.id, "reply": false }
                            // }}>
                                <MessageItem
                                    initails={getInitials(item.resource.extension[3].valueString)}
                                    messageDate={GetAppointmentDate(item.resource.extension[6].valueDateTime) + ' ' + GetMonthName(item.resource.extension[6].valueDateTime)}
                                    sender={item.resource.extension[3].valueString}
                                    messageSubject={item.resource.note[0].text}
                                    messageDescription={item.resource.extension[0].valueString}
                                    replyid={item.resource.id}
                                />
                            // </Link>
                        )}
                        keyExtractor={item => item.resource.id}
                        initialNumToRender={10}
                        windowSize={7}

                    />

                ) : !isGetting && <View style={{
                    flexDirection: "column",
                    justifyContent: 'center', alignItems: 'center'
                }}>
                    <Text style={{ marginTop: 10, }}>No Records Found</Text>
                </View>
            }
        </>
    );
}


// function mapStateToProps(state) {
//     return {
//         SentItems: state.SentItems,
//     }
// }
// function mapDispatchToProps(dispatch) {
//     return {
//         getsSentMessage: (pageSize, pageNumber) => dispatch(fetchSentMessageFromApi(pageSize, pageNumber)),
//         // setMessageItem: (item, screenName) => dispatch(setItemMessage(item, screenName)),

//     }
// }

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(Sent);

export default Sent
